<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('试驾订车订单.用户信息')">
                <a-input v-model="queryParam.userInfo" :maxLength="32" :placeholder="$t('试驾订车订单.用户信息提示')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('试驾订车订单.订单状态')">
                <a-select v-model="queryParam.orderStatus" :placeholder="$t('试驾订车订单.请选择状态')" allowClear>
                  <a-select-option v-for="(item, index) in customDict.CarOrderSellStatusEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('试驾订车订单.类型')">
                <a-select v-model="queryParam.type" :placeholder="$t('试驾订车订单.请选择类型')" allowClear>
                  <a-select-option value="10">{{$t('试驾订车订单.试驾')}}</a-select-option>
                  <a-select-option value="20">{{$t('试驾订车订单.订车')}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('试驾订车订单.汽车品牌')">
                <a-input v-model="queryParam.carName" :maxLength="32" :placeholder="$t('试驾订车订单.汽车品牌提示')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('试驾订车订单.门店')">
                <a-input v-model="queryParam.shopName" :maxLength="32" :placeholder="$t('试驾订车订单.门店提示')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('试驾订车订单.姓名')">
                <a-input v-model="queryParam.name" :maxLength="32" :placeholder="$t('试驾订车订单.姓名提示')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('试驾订车订单.核销码')">
                <a-input v-model="queryParam.code" :maxLength="32" :placeholder="$t('试驾订车订单.核销码提示')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('试驾订车订单.创建时间')">
                <a-range-picker
                  v-model="dateRange"
                  :placeholder="[$t('试驾订车订单.开始时间'), $t('试驾订车订单.结束时间')]"
                  style="width:100%"
                  :show-time="true"
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['carOrder:carOrder:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="userInfo" slot-scope="text, record">
          {{$t('试驾订车订单.昵称')}}：{{ record.nickName || '-' }} <br/>
          {{$t('试驾订车订单.手机号')}}：{{ record.userMobile || '-' }}
        </span>
        <span slot="type" slot-scope="text, record">
          {{ record.type === '10' ? $t('试驾订车订单.试驾') : record.type === '20' ? $t('试驾订车订单.订车') : '-' }}
        </span>
        <span slot="orderStatus" slot-scope="text, record">
          {{ record.orderStatusName || '-' }}
        </span>
        <span slot="reserDate" slot-scope="text, record">
          {{ parseTime(record.reserDate) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDelete(record)" v-hasPermi="['carOrder:carOrder:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCarOrder, delCarOrder } from '@/api/carOrder/carOrder'
import {mapGetters} from 'vuex'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CarOrder',
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 时间范围
      dateRange: [],
      // 查询参数
      queryParam: {
        userInfo: undefined,
        orderStatus: undefined,
        type: undefined,
        carName: undefined,
        name: undefined,
        code: undefined,
        shopName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('试驾订车订单.用户信息'),
          dataIndex: 'userInfo',
          scopedSlots: { customRender: 'userInfo' },
          width: 180,
          align: 'center'
        },
        {
          title: this.$t('试驾订车订单.类型'),
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          align: 'center'
        },
        {
          title: this.$t('试驾订车订单.汽车品牌'),
          dataIndex: 'carName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('试驾订车订单.意向车型'),
          dataIndex: 'model',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('试驾订车订单.姓名'),
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('试驾订车订单.预约人手机号'),
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('试驾订车订单.推荐人'),
          dataIndex: 'reference',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('试驾订车订单.门店'),
          dataIndex: 'shopName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('试驾订车订单.订单状态'),
          dataIndex: 'orderStatus',
          scopedSlots: { customRender: 'orderStatus' },
          align: 'center'
        },
        // {
        //   title: this.$t('试驾订车订单.预约时间'),
        //   dataIndex: 'reserDate',
        //   scopedSlots: { customRender: 'reserDate' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('试驾订车订单.核销码'),
          dataIndex: 'code',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('试驾订车订单.创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询试驾订车订单列表 */
    getList () {
      this.loading = true
      const param = { ...this.queryParam }
      if (this.dateRange && this.dateRange.length === 2) {
        param.createBeginTime = this.dateRange[0].format('YYYY-MM-DD HH:mm:ss')
        param.createEndTime = this.dateRange[1].format('YYYY-MM-DD HH:mm:ss')
      } else {
        param.createBeginTime = undefined
        param.createEndTime = undefined
      }
      // 用户信息搜索框同时搜索昵称和手机号（OR关系）
      if (param.userInfo) {
        param.nickName = param.userInfo
      }
      delete param.userInfo
      pageCarOrder(param).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.dateRange = []
      this.queryParam = {
        userInfo: undefined,
        orderStatus: undefined,
        type: undefined,
        carName: undefined,
        name: undefined,
        code: undefined,
        shopName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delCarOrder(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    }
  }
}
</script>
